import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=398f1a2b&scoped=true&"
import script from "./NewButton.vue?vue&type=script&lang=js&"
export * from "./NewButton.vue?vue&type=script&lang=js&"
import style0 from "./NewButton.vue?vue&type=style&index=0&id=398f1a2b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f1a2b",
  null
  
)

export default component.exports